export default __webpack_public_path__ + "static/vatitude-53c8ad4fd3977d6c832a831a91079981.jpg";